var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", [
    _c("hr", { staticClass: "dropdown-separator" }),
    _c("li", { staticClass: "grader grader-submissions" }, [
      _c(
        "a",
        {
          staticClass: "grader-submissions-link",
          attrs: { href: "/arena/admin/" }
        },
        [_vm._v(_vm._s(_vm.T.wordsLatestSubmissions))]
      )
    ]),
    _c("li", { staticClass: "grader grader-status" }, [
      _vm._v(_vm._s(_vm.graderStatusMessage))
    ]),
    _vm.status === "ok"
      ? _c("li", { staticClass: "grader grader-broadcaster-sockets" }, [
          _vm._v(
            " Broadcaster sockets: " +
              _vm._s(
                _vm.graderInfo !== null
                  ? _vm.graderInfo.broadcaster_sockets
                  : ""
              ) +
              " "
          )
        ])
      : _vm.error !== null
      ? _c("li", { staticClass: "grader grader-broadcaster-sockets" }, [
          _vm._v(" API api/grader/status call failed: "),
          _c("pre", { staticStyle: { width: "40em" } }, [
            _vm._v(_vm._s(_vm.error))
          ])
        ])
      : _vm._e(),
    _vm.status === "ok"
      ? _c("li", { staticClass: "grader grader-embedded-runner" }, [
          _vm._v(
            " Embedded runner: " +
              _vm._s(
                _vm.graderInfo !== null ? _vm.graderInfo.embedded_runner : ""
              ) +
              " "
          )
        ])
      : _vm._e(),
    _vm.status === "ok"
      ? _c("li", { staticClass: "grader grader-queues" }, [
          _vm._v(" Queues: "),
          _vm.graderInfo !== null
            ? _c("pre", {
                staticStyle: { width: "250px" },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.ui.prettyPrintJSON(_vm.graderInfo.queue)
                  )
                }
              })
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }